"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCompareImage = void 0;
var _vue = _interopRequireDefault(require("vue"));
var _imageCompare = _interopRequireDefault(require("./image-compare.vue"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const createCompareImage = propsData => {
  const Instance = _vue.default.extend(_imageCompare.default);
  const container = document.body;
  const instance = new Instance({
    el: container.appendChild(document.createElement("div")),
    propsData: {
      ...propsData
    },
    destroyed() {
      container.removeChild(instance.$el);
    }
  });
};
exports.createCompareImage = createCompareImage;